import styled from 'styled-components';
import { Flex } from 'UI';

export const SellerCardStyled = styled(Flex)<{ active: boolean }>`
  max-width: 400px;
  min-width: 400px;
  min-height: 125px;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  background-color: ${({ active, theme }) => (active ? theme.color.grey90_dark : theme.color.grey90)};

  :hover {
    transform: scale(1.02);
  }
`;

export const BlackBox = styled(Flex)`
  display: flex;
  background-color: black;
  border-radius: 10px;
  max-width: 125px;
  text-align: center;
`;
